import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS, GRADIENTS } from '@components/web/src/styles';

export const AnswerContainer = styled(Flexbox)`
  background: ${GRADIENTS.primaryGradient};
  flex: 1 1 0%;
  justify-content: space-between;
`;

export const ButtonSection = styled(Flexbox)`
  position: sticky;
  bottom: 0;
  background: ${COLORS.base.white};
  box-shadow: 0px -8px 18px 0px rgba(16, 24, 40, 0.15);

  .full-width-button {
    width: 100%;
  }
`;
